import { isSingleLineListView } from 'owa-mail-layout';
import { PreviewLinesOption } from '../store/schema/PreviewLinesOption';

// Client-side display only: MCL-only Inline shows as 0 Lines in SCL; not saved to the service.
export default function resolveInlineToSCLZeroLine(
    previewLines: number,
    isSingleLineView: boolean = isSingleLineListView()
): number {
    return previewLines === PreviewLinesOption.Inline && !isSingleLineView
        ? PreviewLinesOption.Off
        : previewLines;
}
